import { defineMessages } from 'react-intl';

/** The copy of the command palette as the app search (design navigation-v2 e 5d). */
export const commandPaletteMessages = defineMessages({
  // The native apps read `app.sml.command-palette.placeholder`; the web placeholder has its own id.
  placeholder: {
    id: 'app.sml.command-palette.placeholderPages',
    defaultMessage: 'Search artists, tracks, playlists and pages',
  },
  legacyPlaceholder: {
    id: 'app.sml.command-palette.placeholder',
    defaultMessage: 'Search artists, tracks, playlists...',
  },
  sectionPages: { id: 'app.sml.command-palette.section.pages', defaultMessage: 'Pages and actions' },
  tabTitle: { id: 'app.sml.command-palette.tabTitle', defaultMessage: '{page} · {tab}' },
  typeGoTo: { id: 'app.sml.command-palette.type.goTo', defaultMessage: 'Go to' },
  typeSettings: { id: 'app.sml.command-palette.type.settings', defaultMessage: 'Settings' },
  seeAll: { id: 'app.sml.command-palette.seeAll', defaultMessage: 'See all results with filters in Search' },
  searchHint: { id: 'app.sml.command-palette.searchHint', defaultMessage: 'Search' },
  sectionArtists: { id: 'app.sml.command-palette.section.artists', defaultMessage: 'Artists' },
  sectionTracks: { id: 'app.sml.command-palette.section.tracks', defaultMessage: 'Tracks' },
  sectionPlaylists: { id: 'app.sml.command-palette.section.playlists', defaultMessage: 'Playlists' },
  typeArtist: { id: 'app.sml.command-palette.type.artist', defaultMessage: 'Artist' },
  typeTrack: { id: 'app.sml.command-palette.type.track', defaultMessage: 'Track' },
  typePlaylist: { id: 'app.sml.command-palette.type.playlist', defaultMessage: 'Playlist' },
  noResults: { id: 'app.sml.command-palette.no-results', defaultMessage: 'No results found' },
  noResultsDescription: {
    id: 'app.sml.command-palette.no-results.description',
    defaultMessage: 'Try a different search term.',
  },
  searching: { id: 'app.sml.command-palette.searching', defaultMessage: 'Searching...' },
  navigate: { id: 'app.sml.command-palette.navigate', defaultMessage: 'Navigate' },
  select: { id: 'app.sml.command-palette.select', defaultMessage: 'Select' },
  close: { id: 'app.sml.command-palette.close', defaultMessage: 'Close' },
});
